import React, { Component } from "react"
import PropTypes from "prop-types"

// components
import FilterHeader from "app/static/frontend/search-new/components/Filter/FilterHeader"

export default class Filter extends Component {
    state = {
        filterContainsSearchFilterTerm: false,
        filterHeaderContainsSearchFilterTerm: false,
        shouldUnmountFilter: true,
    }
    setFilterContainsSearchFilterTerm = (filterContainsSearchFilterTerm) => {
        if (!this.state.filterContainsSearchFilterTerm && filterContainsSearchFilterTerm) {
            this.setState({
                filterContainsSearchFilterTerm,
            })
        }
    }
    setFilterHeaderContainsSearchFilterTerm = (filterHeaderContainsSearchFilterTerm) => {
        if (!this.state.filterHeaderContainsSearchFilterTerm && filterHeaderContainsSearchFilterTerm) {
            this.setState({
                filterHeaderContainsSearchFilterTerm,
            })
        }
    }

    // getDerivedStateFromProps is invoked right before calling the render method,
    // both on the initial mount and on subsequent updates.
    // It should return an object to update the state, or null to update nothing.
    // This method exists for rare use cases where the state depends on changes in props over time.
    // reactjs.org/docs/react-component.html#static-getderivedstatefromprops

    // getDerivedStateFromProps is static to help ensure purity
    // (no access to instance properties),
    // which reduces risk when writing async-compatible React components.
    // https://twitter.com/dan_abramov/status/979745329649213440
    // https://stackoverflow.com/a/57950655/6201291
    // https://github.com/reactjs/rfcs/pull/6/files/b7189ccf42c5f8c039d268841efdfda296eec411#diff-5e06005dbc26fcac5989745eaca87e80R161
    static getDerivedStateFromProps(props, state) {
        if (
            // when we clear this.props.searchFilterTerm in the parent component,
            // we want to ensure that we reset the state before the next Filter render() is called
            (!props.searchFilterTerm && state.filterContainsSearchFilterTerm) ||
            // when the searchFilterTerm changes, reset the state
            // can it can be recomputed in each Filter that re-renders
            (props.searchFilterTerm && props.searchFilterTerm !== state.searchFilterTerm)
        ) {
            return {
                filterContainsSearchFilterTerm: false,
                filterHeaderContainsSearchFilterTerm: false,
                searchFilterTerm: props.searchFilterTerm,
                shouldUnmountFilter: true,
            }
        }

        return {
            searchFilterTerm: props.searchFilterTerm,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // same approach as the one from
        // app/static/frontend/search-new/components/FilterGroup/index.js
        // , but instead of hiding the FilterGroup if none of its subfilters contains the searchTerm,
        // we hide the individual Filter if neither the FilterHeader nor PresentationComponent contains the searchTerm
        if (
            // if we have a valid filter search term and either
            // the FilterHeader or the PresentationComponent contain the search term
            this.props.searchFilterTerm &&
            (prevState.filterHeaderContainsSearchFilterTerm !== this.state.filterHeaderContainsSearchFilterTerm ||
                prevState.filterContainsSearchFilterTerm !== this.state.filterContainsSearchFilterTerm) && // FilterHeader case:
            // we need to check both
            // this.state.filterHeaderContainsSearchFilterTerm
            // this.state.filterContainsSearchFilterTerm
            // since we render both FilterHeader and PresentationComponent
            ((this.props.displayLabel &&
                (this.state.filterHeaderContainsSearchFilterTerm || this.state.filterContainsSearchFilterTerm)) ||
                // PresentationComponent case:
                // we only need to check this.state.filterContainsSearchFilterTerm
                // since we only render PresentationComponent
                (!this.props.displayLabel && this.state.filterContainsSearchFilterTerm))
        ) {
            this.setState({
                shouldUnmountFilter: false,
            })
        }
    }

    renderFilterHeader(displayLabel) {
        return (
            <FilterHeader
                helpText={this.props.helpText}
                label={displayLabel}
                // TODO: connect this to enum filter_groups "collapseGroup": True
                isCollapsedGroup={this.props.uniqueFilterId === "stafferTypeFilter"}
                invisible={this.props.invisible}
                searchFilterTerm={this.props.searchFilterTerm}
                setFilterGroupContainsSearchFilterTerm={this.props.setFilterGroupContainsSearchFilterTerm}
                setFilterHeaderContainsSearchFilterTerm={this.setFilterHeaderContainsSearchFilterTerm}
            />
        )
    }

    render() {
        const PresentationComponent = this.props.presentationComponent

        return (
            <div
                className={!this.props.isSubSubfilter ? "filter-header-design-system" : ""}
                style={{
                    ...// if we have a valid filter search term
                    (this.props.searchFilterTerm &&
                        // and we have a Filter to hide
                        this.state.shouldUnmountFilter &&
                        // and it's not a subfilter
                        // (we never want to hide subfilters since they will be
                        // automatically hidden if their parent Filter is hidden)
                        !this.props.isSubfilter &&
                        // and it's not the edge case where the FilterGroup ExpandableDropdown title
                        // contains the search term but none of the FilterComponent do
                        // app/static/frontend/search-new/components/FilterGroup/index.js
                        !this.props.shouldAlwaysDisplayFilter && { display: "none" }),
                    ...(this.props.isSubSubfilter && {
                        minWidth: 0,
                        width: "100%",
                    }),
                }}
            >
                {this.props.displayLabels
                    ? this.props.displayLabels.map((displayLabel) => this.renderFilterHeader(displayLabel))
                    : this.renderFilterHeader(this.props.displayLabel)}
                <PresentationComponent
                    deserializedValue={this.props.deserializedValue}
                    publishChange={this.props.updateFilter}
                    setFilterContainsSearchFilterTerm={this.setFilterContainsSearchFilterTerm}
                    {...this.props}
                />
            </div>
        )
    }
}
Filter.propTypes = {
    // when passing singular displayLabel, do not pass array of displayLabels
    displayLabel: PropTypes.string,
    // when passing displayLabels, do not pass singular displayLabel
    displayLabels: PropTypes.array,
    filterGroupIsOpen: PropTypes.bool.isRequired,
    helpText: PropTypes.string,
    isSubfilter: PropTypes.bool,
    presentationComponent: PropTypes.func.isRequired,
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm: PropTypes.string,
    // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
    setFilterGroupContainsSearchFilterTerm: PropTypes.func,
    updateFilter: PropTypes.func.isRequired,
}
